import { render } from "./NewProfileModal.vue?vue&type=template&id=754a818e"
import script from "./NewProfileModal.vue?vue&type=script&lang=js"
export * from "./NewProfileModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__